import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  countries: [],
  states: [],
  cities: [],
  fetchingCountries: false,
  fetchingStates: false,
  fetchingCities: false,
  labDetails: null,
};

const labEditSlice = createSlice({
  name: "labEdit",
  initialState,
  reducers: {
    fetchLabDetails(state, action) {
      state.loading = true;
    },
    fetchLabDetailsSuccess(state, action) {
      state.labDetails = action.payload.data.document;
      state.loading = false;
    },
    fetchLabDetailsFailure(state, action) {
      state.loading = false;
    },
    updateLab(state, action) {
      state.loading = true;
      state.error = null;
    },
    updateLabSuccess(state, action) {
      state.error = null;
      state.loading = false;
    },
    updateLabFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeError(state, action) {
      state.error = null;
    },
    fetchCountries(state, action) {
      state.fetchingCountries = true;
    },
    fetchCountriesSuccess(state, action) {
      state.fetchingCountries = false;
      state.countries = action.payload.data.document;
    },
    fetchCountriesFailure(state, action) {
      state.fetchingCountries = false;
    },
    fetchStates(state, action) {
      state.fetchingStates = true;
    },
    fetchStatesSuccess(state, action) {
      state.fetchingStates = false;
      state.states = action.payload.data.document;
    },
    fetchStatesFailure(state, action) {
      state.fetchingStates = false;
    },
    fetchCities(state, action) {
      state.fetchingCities = true;
    },
    fetchCitiesSuccess(state, action) {
      state.fetchingCities = false;
      state.cities = action.payload.data.document;
    },
    fetchCitiesFailure(state, action) {
      state.fetchingCities = false;
    },
    initializeState(state, action) {
      state.loading = false;
      state.error = null;
      state.countries = [];
      state.states = [];
      state.cities = [];
      state.fetchingCountries = false;
      state.fetchingStates = false;
      state.fetchingCities = false;
      state.labDetails = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = labEditSlice;
